import React, { PureComponent } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

export default class Index extends PureComponent {
  render() {
    return (
      <div
        style={{
          minHeight: 'calc(100vh - 500px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Helmet title="Not Found" />
        <div
          style={{
            maxWidth: '560px',
            backgroundColor: '#fff',
            padding: '80px 30px',
            margin: '0px auto',
            borderRadius: '10px',
            flex: '1',
          }}
        >
          <div
            style={{
              maxWidth: '400px',
              margin: '0 auto',
            }}
          >
            <img src="/resources/images/pages/page_not_found.svg" width="400" alt="404 page" />
            <h1 className="font-size-36 mb-2">Page not found</h1>
            <p className="mb-3">The page is deprecated, deleted, or does not exist at all</p>
            <Link to="/" className="btn">
              &larr; Go back to the home page
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
